import { cn } from '@/lib/utils';

const PROJECT_TITLE_WIDTHS = ['w-1/4', 'w-1/3', 'w-2/5'];
const THREAD_GROUPS = [
    { label: 'w-24', titles: ['w-4/5', 'w-3/5', 'w-2/3', 'w-3/4'] },
    { label: 'w-28', titles: ['w-3/4', 'w-4/5', 'w-1/2', 'w-2/3', 'w-3/5'] }
];

function Bar({ className }: { className: string }) {
    return <div className={cn('skeleton-shimmer rounded-md', className)} />;
}

export function SidebarListSkeleton() {
    return (
        <div
            role="status"
            aria-busy="true"
            className="flex flex-col gap-6 px-3 pt-2"
        >
            <span className="sr-only">Loading</span>
            <div className="flex flex-col gap-3">
                <Bar className="w-16 h-3" />
                {PROJECT_TITLE_WIDTHS.map((title) => (
                    <div key={title} className="flex items-center gap-3">
                        <Bar className="size-5 shrink-0" />
                        <Bar className={cn('h-3.5', title)} />
                    </div>
                ))}
            </div>
            {THREAD_GROUPS.map((group) => (
                <div key={group.label} className="flex flex-col gap-3.5">
                    <Bar className={cn('h-3', group.label)} />
                    {group.titles.map((title, index) => (
                        <div
                            key={`${title}-${index}`}
                            className="flex items-center gap-3 pl-1"
                        >
                            <Bar className="rounded-full size-2 shrink-0" />
                            <Bar className={cn('h-3.5', title)} />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
